<template>
  <div class="min-vh-100">
    <router-view></router-view>
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'App' });
</script>

<style></style>
